<ng-container *ngIf="data$ | async as data">
  <div
    class="footer-container"
    [style.display]="hasRequested === 'true' ? 'none' : 'block'"
    [class.footer-asm-container]="asmEnabled"
  >
    <div class="footer-label" [innerHTML]="data?.label"></div>
    <div class="footer-phone" *ngIf="(data?.phoneNumber | json) !== '{}'">{{ data?.phoneNumber }}</div>
    <div class="footer-email" *ngIf="(data?.email | json) !== '{}'">{{ data?.email }}</div>
    <div class="footer-links" *ngIf="imageLinks?.length">
      <div *ngFor="let slide of imageLinks">
        <a href="{{ slide.url }}" target="_blank">
          <cx-media [container]="slide.media"></cx-media>
        </a>
      </div>
    </div>
  </div>
</ng-container>
